@if (problemInfo) {
  <section class="lesson-content">
    <div class="lesson-problem">
      <app-content-viewer [content]="problemInfo.problem.content"></app-content-viewer>
      @if (utilitiesService.problemHasContentPassage(problemInfo.problem)) {
        <div class="lesson-passage" >
          <app-content-viewer [content]="problemInfo.problem.passage.content"></app-content-viewer>
        </div>
      }
    </div>
    <div class="lesson-answers">
      <app-multi-choice
        [options]="problemInfo.problem.answers"
        [title]="title"
        [correctTitle]="correctTitle"
        [incorrectTitle]="incorrectTitle"
        [discardedOptions]="discardedOptions"
        (optionSelected)="onUserSelection($event)"
        (readyToContinue)="handleReadyToContinue()"
        >
      </app-multi-choice>
      @if (isLoading) {
        <app-spinner></app-spinner>
      }
      @if (readyToContinue) {
        <a class="btn btn-lg btn-block btn-primary" (click)="handleNext()">Next</a>
      }
    </div>
  </section>
} @else {
  <app-spinner></app-spinner>
}

